<template>
  <v-card flat>
    <v-card-text>

      <v-tabs slider-color="primary" v-model="activeTab">
        <v-tab v-for="account in bankAccounts" :key="account.id" ripple>
          {{ account.bank }}
        </v-tab>

        <v-tab ripple>
          {{ $t('paymentProof') }}
        </v-tab>

        <v-tab-item v-for="account in bankAccounts" :key="account.id">
          <v-card flat>
            <v-card-text>
              <v-layout row wrap>

                <v-flex xs12 sm12 md6>
                  <h4> {{ $t('addFundsStep1', { amount: minAmount, currency: currency }) }} </h4>

                  {{ $t('attrs.bank') }}:
                  <strong> {{ account.bank }} </strong>

                  <br />
                  {{ $t('attrs.account_number') }}:
                  <strong> {{ account.account_number }} </strong>

                  <br />
                  {{ $t('attrs.clabe') }}:
                  <strong> {{ account.clabe }} </strong>

                  <br />
                  {{ $t('attrs.beneficiary') }}:
                  <strong> {{ account.beneficiary }} </strong>

                  <br />
                  {{ $t('attrs.rfc') }}:
                  <strong> {{ account.rfc }} </strong>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <h4> {{ $t('addFundsStep2') }} </h4>

                  {{ $t('attrs.email') }}:
                  <strong> {{ email }} </strong>

                  <br />
                  {{ $t('addFundsSubject') }}:
                  <strong> {{ $t('addFundsSubjectVal') }} </strong>

                  <br />
                  <ul>
                    <li>{{ $t('addFundsIncludeEmail', { company: company }) }}</li>
                    <li>{{ $t('addFundsIncludeVoucher') }}</li>
                    <li @click="openPaymentProofTab"><a>{{ $t('addFundsIncludeForm') }}</a></li>
                  </ul>

                </v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <Payment-proof></Payment-proof>
        </v-tab-item>
      </v-tabs>

    </v-card-text>
  </v-card>
</template>

<script>
  import PaymentProof from '@/components/funds/payment-proof.vue'

  export default {
    name: 'AddFundsBankAccountsComp',

    props: {
      bankAccounts: {
        type: Array,
        default: () => []
      },

      settings: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        activeTab: 0
      }
    },

    components: {
      PaymentProof
    },

    computed: {
      minAmount () {
        if (!this.settings) { return }
        const amount = this.settings.find(o => o.key === 'bank_amount') || {}
        return this.$options.filters.currency(amount.value || 0)
      },

      currency () {
        if (!this.settings) { return }
        const currency = this.settings.find(o => o.key === 'currency') || {}
        return currency.value || 'MXN'
      },

      email () {
        if (!this.settings) { return }
        const email = this.settings.find(o => o.key === 'bank_email') || {}
        return email.value || ''
      }
    },

    methods: {
      openPaymentProofTab () {
        this.activeTab = this.bankAccounts.length
      }
    },

    watch: {
    },

    async mounted () { 
    }
  }
</script>
